import { SHIPPED_BOT_AVATAR_SHAPE_KEYS } from "./bot-avatar-shapes.js";

// Keep the visor inside narrow contours without changing the saved shape. / Візор у вузькому контурі без зміни збереженої форми.
const SHAPE_FACE_FIT: Partial<
  Record<(typeof SHIPPED_BOT_AVATAR_SHAPE_KEYS)[number], { scale: number; offsetY: number }>
> = {
  wedge: { scale: 0.95, offsetY: 0.09 },
  teardrop: { scale: 0.9, offsetY: 0.04 },
  cross: { scale: 0.82, offsetY: 0 },
  diamond: { scale: 0.88, offsetY: 0 },
  star: { scale: 0.74, offsetY: 0.015 },
  capsule: { scale: 0.86, offsetY: 0 },
  flower: { scale: 0.9, offsetY: 0 },
};

export function robotAvatarFaceLayout(size: number, shapeIndex?: number) {
  const key =
    shapeIndex === undefined
      ? undefined
      : SHIPPED_BOT_AVATAR_SHAPE_KEYS[shapeIndex % SHIPPED_BOT_AVATAR_SHAPE_KEYS.length];
  const fit = key === undefined ? undefined : SHAPE_FACE_FIT[key];
  const faceSize = size * (fit?.scale ?? 1);
  const visorW = Math.round(faceSize * 0.68);
  const visorH = Math.round(faceSize * 0.44);
  const visorInnerW = Math.max(0, visorW - 2);
  const visorInnerH = Math.max(0, visorH - 2);
  const preferredEyeW = Math.max(4, Math.round(faceSize * 0.14));
  const preferredEyeH = Math.max(7, Math.round(faceSize * 0.22));
  const preferredEyeGap = Math.max(3, Math.round(faceSize * 0.1));
  const preferredSpan = preferredEyeW * 2 + preferredEyeGap;
  const scale = Math.min(1, visorInnerW / preferredSpan, visorInnerH / preferredEyeH);
  const eyeW = Math.floor(preferredEyeW * scale);
  const eyeH = Math.floor(preferredEyeH * scale);
  const eyeGap = Math.floor(preferredEyeGap * scale);
  const eyeRadius = Math.max(2, Math.round(eyeW * 0.5));
  return { visorW, visorH, eyeW, eyeH, eyeGap, eyeRadius, offsetY: size * (fit?.offsetY ?? 0) };
}
